// Forms Toggle Switch

import 'bootstrap4-toggle/js/bootstrap4-toggle';

$(document).ready(() => {



});